// @flow
export function isUndefined(value): boolean {
  return value === undefined
}
